import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="initialize-twofactor"
export default class extends Controller {

  static targets = [
    "trigger",
    "content",
    "code",
    "authenticatorCode",
    "authenticatorCurrentPassword",
    "authenticatorSuccess",
    "authenticatorError"
  ]

  connect() {
  }

  open(event) {
    event.preventDefault();
    this.contentTarget.classList.toggle("hidden");
    event.target.classList.add("opacity-50","pointer-events-none");
  }

  close(event) {

    event.preventDefault();
    this.contentTarget.classList.toggle("hidden");
    this.triggerTarget.classList.remove("opacity-50","pointer-events-none");

  }

  verifyAuthenticatorCode(event) {
    event.preventDefault();
    const data = {
      two_fa: {
        code: this.authenticatorCodeTarget.value,
        password: this.authenticatorCurrentPasswordTarget.value,
        two_fa_method: 'authenticator'
      }
    };

    this.verifyCode(data, this.authenticatorSuccessTarget, this.authenticatorErrorTarget);
  }

  verifyCode(data, successTarget, errorTarget) {
    fetch('/two_factor', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector('[name=csrf-token]').content,
      },
      body: JSON.stringify(data)
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success") {
        // Reload the page to reflect the changes
        location.reload();
      } else {
        // Display the error message
        errorTarget.classList.remove('hidden');
        errorTarget.textContent = data.message;

        // Hide the success message if it was previously displayed
        successTarget.classList.add('hidden');
      }
    })
    .catch((error) => {
      // Display the error message
      errorTarget.classList.remove('hidden');
      errorTarget.textContent = error.message;

      // Hide the success message if it was previously displayed
      successTarget.classList.add('hidden');
    });
  }
}
